export default __webpack_public_path__ + "static/media/36I-102807_-15995_0.88f8acac.jpg";